// extracted by mini-css-extract-plugin
export default {"wrapper":"Switch_wrapper__vu4zy","label":"Switch_label__Y0HqU","active":"Switch_active__8r78m"};